import { useEffect, useState } from "react";
import { useContextSite } from "../../../context/Context";
import { IVeiculoForm } from "../../../types/veiculo";
import { useNavigate, useParams } from "react-router-dom";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";
import { TipoAtendimentoEnum } from "../../../enums/tipoAtendimento";
import { getTipoVeiculoCode, getTipoVeiculoLabel, TipoVeiculoEnum } from "../../../enums/tipoVeiculo";
import { ISelectOptions } from "../../../types/inputs";

interface RouteParams extends Record<string, string> {
    uuidAgendamento: string;
}

const tipoOptions = Object.values(TipoVeiculoEnum).map((tipo) => ({
    value: tipo,
    label: getTipoVeiculoLabel(tipo),
    code: getTipoVeiculoCode(tipo)
}))

export const useVehicleRegister = () => {
    const { isLoad, setIsLoad } = useContextSite();
    const [form, setForm] = useState<IVeiculoForm>({} as IVeiculoForm);
    const navigate = useNavigate();
    const [agendamento, setAgendamento] = useState<IAgendamentoDTO>();
    const { uuidAgendamento } = useParams<RouteParams>();
    const [tipo, setTipo] = useState<ISelectOptions>()

    useEffect(() => {
        setIsLoad(true);
    
        Agendamento.getById({ uuid: uuidAgendamento })
            .then(({ data }) => {
                setAgendamento(data);
            })
            .catch(
                ({
                response: {
                    data: { mensagem },
                },
                }) => {
                toast.error(mensagem);
                }
            )
            .finally(() => setIsLoad(false));
    }, []);

    function handleSubmit(e: React.SyntheticEvent) {
        e.preventDefault();
        setIsLoad(true);

        Agendamento.vincularVeiculoPrimeiroRegistro({
            uuidAgendamento: agendamento?.uuid,
            veiculoForm: form
        })
        .then(({ data }) => {
            if (data?.tipoAtendimento === TipoAtendimentoEnum.LOJA) {
                if (data?.revistoria) {
                    navigate(`/meus-agendamentos/agendamento?id=${data?.uuid}`);
                    return;
                }

                navigate(`/agendamento/${uuidAgendamento}/pagamento`);
                return;
            }

            if (data?.concessionaria) {
                navigate(
                    `/agendamento/${uuidAgendamento}/servicos/cadastro-endereco-concessionaria`
                );

                return;
            }

            if (data?.delivery?.uuid) {
                navigate(
                    `/agendamento/${uuidAgendamento}/servicos/cadastro-endereco`
                );

                return;
            }

            if (data?.itinerante?.uuid) {
                if (data?.revistoria) {
                    navigate(`/meus-agendamentos/agendamento?id=${data?.uuid}`);
                    return;
                }

                navigate(`/agendamento/${uuidAgendamento}/pagamento`);
                return;
            }

            navigate(
                `/agendamento/${uuidAgendamento}/servicos/cadastro-endereco`
            );
        })
        .catch(
            ({
                response: {
                data: { mensagem },
                },
            }) => {
                toast.error(mensagem);
            }
        )
        .finally(() => setIsLoad(false));
    }

    return { handleSubmit, isLoad, form, setForm, tipoOptions, tipo, setTipo };
};